import { CalendarComponent } from './components/calendar/calendar.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountRouting, AuthRouting, IsAlreadyLoggedGuard, IsLoggedGuard } from '@argalis-apps/angular-core';
import { HomePageComponent } from './components/home-page/home-page.component';
import { MainUiComponent } from './components/main-ui/main-ui.component';
import { SigninComponent } from './components/signin/signin.component';
import { DemandesEncadrementListComponent } from './components/demandes-encadrement-list/demandes-encadrement-list.component';
import { DemandesEncadrementDetailsComponent } from './components/demandes-encadrement-details/demandes-encadrement-details.component';

const routes: Routes = [
  {
    path: 'auth',
    children: AuthRouting
  },
  {
    path: 'signin',
    component: SigninComponent,
    canActivate: [IsAlreadyLoggedGuard]
  },
  {
    path: '',
    component: MainUiComponent,
    canActivate: [IsLoggedGuard],
    children: [
      {
        path: '',
        component: HomePageComponent
      },
      {
        path: 'calendar',
        component: CalendarComponent
      },
      {
        path: 'demandes',
        children: [
          {
            path: '',
            redirectTo: 'list',
            pathMatch: 'full'
          },
          {
            path: 'list',
            component: DemandesEncadrementListComponent
          },
          {
            path: 'details/:id',
            component: DemandesEncadrementDetailsComponent
          }
        ]
      },
      {
        path: 'account',
        children: AccountRouting
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
